import { WaytoraExperienceListResponse } from "@/types/experiences";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import api from "@/config/axiosConfig";

const ITEMS_PER_PAGE = 20;

// Viator product list fetching function
const fetchWaytoraExperiences = async ({
  locationId,
  currentPage,
}: {
  locationId: string;
  currentPage: number;
}): Promise<WaytoraExperienceListResponse> => {
  try {
    const response = await api.experiences.get<WaytoraExperienceListResponse>(
      "/general",
      {
        params: {
          location_id: locationId,
          limit: ITEMS_PER_PAGE,
          offset: currentPage * ITEMS_PER_PAGE,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Viator products:", error);
    throw new Error("Failed to fetch Viator products");
  }
};

export const useWaytoraExperiences = (
  locationId: string,
  currentPage: number
) => {
  return useQuery({
    queryKey: ["waytoraExperiences", locationId, currentPage],
    queryFn: () => fetchWaytoraExperiences({ locationId, currentPage }),
    staleTime: Infinity,
    retry: false,
  });
};
